import { IconButton } from '@fullscreendigital/carrefour-dex-fe'

import EditActionIcon from 'icons/EditActionIcon'

const EditButton = ({ onClick }) => (
  <IconButton onClick={onClick} label="Edit">
    <EditActionIcon />
  </IconButton>
)

export default EditButton
